document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(".mdsa-learning-hub");

  sections.forEach((section) => {

    const slider = section.querySelector(".mdsa-learning-hub__articles");
    const cards = section.querySelectorAll(".mdsa-learning-hub__card");

    const prevBtn = section.querySelector(".mdsa-learning-hub__arrow--prev");
    const nextBtn = section.querySelector(".mdsa-learning-hub__arrow--next");


    if (!slider || cards.length === 0) return;


    let currentIndex = 0;


    function getVisibleCards() {

      const width = window.innerWidth;

      if (width < 700) {
        return 1;
      }

      if (width < 1200) {
        return 2;
      }

      return 3;

    }



    function updateSlider() {

      const visible = getVisibleCards();

      const gap = 18;

      const cardWidth = cards[0].offsetWidth + gap;


      slider.style.transform =
        `translateX(-${currentIndex * cardWidth}px)`;


      updateButtons();

    }




    function updateButtons() {


      const visible = getVisibleCards();


      if (prevBtn) {

        prevBtn.disabled = currentIndex === 0;

      }


      if (nextBtn) {

        nextBtn.disabled =
          currentIndex >= cards.length - visible;

      }


    }





    if (nextBtn) {

      nextBtn.addEventListener("click", function () {


        const visible = getVisibleCards();


        if (currentIndex < cards.length - visible) {

          currentIndex += visible;

          updateSlider();

        }


      });

    }





    if (prevBtn) {

      prevBtn.addEventListener("click", function () {


        const visible = getVisibleCards();


        if (currentIndex > 0) {

          currentIndex -= visible;


          if (currentIndex < 0) {

            currentIndex = 0;

          }


          updateSlider();

        }


      });

    }







    window.addEventListener("resize", function () {


      const maxIndex =
        Math.max(0, cards.length - getVisibleCards());


      if (currentIndex > maxIndex) {

        currentIndex = maxIndex;

      }


      updateSlider();


    });




    updateSlider();



  });


});